import { render } from "./EcosystemResources.vue?vue&type=template&id=c25f3a32"
import script from "./EcosystemResources.vue?vue&type=script&lang=js"
export * from "./EcosystemResources.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__